export default "__VITE_ASSET__DxcydUMw__"